// @todo change icons
export const OrderTypesIcons = {
  DELIVERY_ICON: "hkfi-delivery",
  TAKEAWAY_ICON: "hkfi-minus",
  DINE_IN_ICON: "hkfi-minus",
};

export const OrderTypesCode = {
  DELIVERY_CODE: "D",
  TAKEAWAY_CODE: "P",
  TAKEAWAY_ALTERNATE_CODE: "T",
  DINE_IN_CODE: "DINEIN",
};

export const OrderTypesFromCode = {
  D: "Delivery",
  P: "Takeaway",
  DINEIN: "Dine in",
};

export const OrderTypesTextForCurrentOrderFromCode = {
  D: "Delivering to ",
  P: "Takeaway",
  DINEIN: "Dine in",
};

export const OrderTypesTextForPastOrderFromCode = {
  D: "Delivered to ",
  P: "Takeaway",
  DINEIN: "Dine in",
};

export const OrderTypesTextForFailedOrderFromCode = {
  D: "Delivery to ",
  P: "Takeaway",
  DINEIN: "Dine in",
};

export const OrderTypesTextForAdvanceOrderFromCode = {
  D: "Deliver to ",
  P: "Takeaway from",
  DINEIN: "Dine in at",
};

export const OrderTypesTextPrefixForCart = {
  D: "To",
  P: "From",
  DINEIN: "At",
};
